import React from "react"
import { useTranslation } from "react-i18next"
import moment from "moment"

/** Tanlangan davr turi */
export type QuickRange = "all" | "day" | "week" | "month" | "year"

export interface DateRange {
  begin?: string
  end?: string
}

/**
 * Tanlangan davrni so'rov parametrlariga aylantiradi.
 *
 * Chegaralar KUN aniqligida olinadi: kunning boshidan oxirigacha.
 * Aks holda "bugun" degan filtr hozirgi soatdan boshlanib, ertalabki
 * savdolarni tashlab ketardi.
 */
export function rangeToParams(range: QuickRange): DateRange {
  if (range === "all") return {}

  const unit =
    range === "day" ? "day" : range === "week" ? "isoWeek" : range === "month" ? "month" : "year"

  return {
    begin: moment().startOf(unit as any).format("YYYY-MM-DDTHH:mm:ss"),
    end: moment().endOf(unit as any).format("YYYY-MM-DDTHH:mm:ss"),
  }
}

/**
 * Kun / hafta / oy / yil bo'yicha tez filtr.
 *
 * Sana tanlagichdan farqi — bir bosishda ishlaydi. Telefonda ikkita
 * sanani kalendardan terib o'tirish noqulay, ko'p hollarda esa
 * odamga aynan shu to'rt oraliqdan biri kerak bo'ladi.
 */
export default function QuickDateFilter(props: {
  value: QuickRange
  onChange: (value: QuickRange) => void
}) {
  const { t } = useTranslation()

  const items: { key: QuickRange; label: string }[] = [
    { key: "all", label: String(t("quickAll")) },
    { key: "day", label: String(t("quickToday")) },
    { key: "week", label: String(t("quickWeek")) },
    { key: "month", label: String(t("quickMonth")) },
    { key: "year", label: String(t("quickYear")) },
  ]

  return (
    <div className="mb-quick">
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          className={`mb-quick-item${props.value === it.key ? " mb-quick-on" : ""}`}
          onClick={() => props.onChange(it.key)}
        >
          {it.label}
        </button>
      ))}
    </div>
  )
}
